export default "__VITE_ASSET__$Xf85QG1__"